import { render, staticRenderFns } from "./newTransScanIn.vue?vue&type=template&id=d4696d96&scoped=true&"
import script from "./newTransScanIn.vue?vue&type=script&lang=js&"
export * from "./newTransScanIn.vue?vue&type=script&lang=js&"
import style0 from "./newTransScanIn.vue?vue&type=style&index=0&id=d4696d96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4696d96",
  null
  
)

component.options.__file = "newTransScanIn.vue"
export default component.exports